var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","tile":"","data-testid":"top-header-menu"}},[_c('v-toolbar',{staticClass:"pa-0",attrs:{"flat":"","short":"","tile":"","height":"30px"}},[_c('v-toolbar-title'),_c('v-spacer'),_c('menu-items')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }